<template>
  <div>
    <ContentHeader :class="layout.desktop + ' mb-terms-content-header mb-simple-header'"
                   :title="$t('safeometer_termsOfUse')"
                   :fsize="`35px`"
                   :line-height="`45px`"
    />

    <ContentHeader :class="layout.mobile + ' mb-terms-content-header mb-simple-header'"
                   :title="$t('safeometer_termsOfUse')"
                   :fsize="`28px`"
                   :line-height="`36px`"
    />
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="mb-terms-content-desc" v-html="$t('safeometer_termsOfUse_description')"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader";
import { BContainer } from 'bootstrap-vue';
import { BRow } from 'bootstrap-vue';
import { BCol } from 'bootstrap-vue';

export default {
  name: "Terms",
  components:{
    ContentHeader,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol
  },
  mounted() {
    window.scrollTo(0,0);
  },
  data(){
    return {
      layout: this.$responsiveLayout
    }
  }
}
</script>

<style scoped>
  .mb-terms-content-desc {
    text-align: left;
    margin-top: 1em;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
</style>